/* eslint-disable no-param-reassign */
// initial state
import { handleCookies } from '@/static/helpers';
import { serviceWrapper, serviceConfigs } from '@/services/configs';

const state = {
  token: null,
  closingDay: null,
  expireAlertText: null,
  tutorialStatus: false,
  auth: null,
  firstLogin: false,
  currentUser: {
    closingDayCount: 100,
    companyId: 0,
    companyType: 1,
    name: '',
    surname: '',
    fullname: '',
    userId: 0,
    isClosedCompany: false,
    sectorExists: true,
    username: '',
    permissions: [],
    isCrmUser: false,
    nonAuthorizedPermissions: [],
    showDailyLimit: null,
    downloadDailyLimit: null,
    email: '',
  },
  companyContract: {
    link: '',
    companyContractId: null,
  },
  companyGroup: {
    selected: null,
    options: [],
  },
};

// getters
const getters = {
  getToken(state) {
    return state.token;
  },
  getCompanyClosingDate(state) {
    return state.closingDay;
  },
  getExpireAlertText(state) {
    return state.expireAlertText;
  },
  getCurrentUser(state) {
    return state.currentUser;
  },
  getTutorialStatus(state) {
    return state.tutorialStatus;
  },
  getCompanyGroup(state) {
    return state.companyGroup.selected;
  },
  getCompanyGroupOptions(state) {
    return state.companyGroup.options;
  },
  getCompanyContract() {
    return state.companyContract;
  },
  getFirstLogin() {
    return state.firstLogin;
  },
};

// mutations
const mutations = {
  setCompanyClosingDate: (state, value) => {
    state.closingDay = value;
  },
  setFirstLogin: (state) => {
    state.firstLogin = !state.firstLogin;
  },
  setExpireAlertText(state, value) {
    state.expireAlertText = value;
  },

  setCurrentUser(state, value) {
    state.currentUser = {
      ...state.currentUser,
      ...value,
    };
  },

  setTutorialStatus(state, value) {
    state.tutorialStatus = value;
  },

  setCompanyGroup(state, value) {
    if (value) handleCookies.setCookie({ companyGroupId: value.id });
    state.companyGroup.selected = value;
  },

  setCompanyGroupOptions(state, value) {
    state.companyGroup.options = value;
  },

  setDailyLimits(state, res) {
    if (res) {
      res.dailyLimits.forEach((item) => {
        if (item.dailyLimitType === 1) {
          state.currentUser.showDailyLimit = res.maxLimit - item.creditCounter;
        } else {
          state.currentUser.downloadDailyLimit = res.maxLimit - item.creditCounter;
        }
      });
    }
  },

  setCompanyContract(state, val) {
    state.companyContract = { ...val };
  },
  setExpressSearch(state, val) {
    state.currentUser = {
      ...state.currentUser,
      expressSearch: { ...val },
    };
  },
};
// actions
const actions = {
  callSetTutorialStatus(context, value) {
    context.commit('setTutorialStatus', value);
  },
  callSetCompanyGroup(context, value) {
    context.commit('setCompanyGroup', value);
  },
  callSetCompanyGroupOptions(context, value) {
    context.commit('setCompanyGroupOptions', value);
  },
  callFetchDailyLimits(context) {
    serviceWrapper(
      serviceConfigs.companyUser,
      serviceConfigs.companyUser.getDailyLimits,
    )
      .then((res) => {
        context.commit('setDailyLimits', res.data.result);
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
